// extracted by mini-css-extract-plugin
module.exports = {"card":"_15203","title":"_16486","primary":"_12008","icon":"_204","list":"_16090","item":"_15876","progress":"_14321","name":"_2147","desc":"_7179","time":"_12456"};